import React from "react";
import { Card, Typography } from "antd";
import { CarOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const VehicleHeader = ({ vehicleData }) => {
  const { matricule, brand, model } = vehicleData;
  
  return (
    <Card
      className="mb-6 shadow-lg bg-gradient-to-r from-indigo-600 to-purple-600 text-white"
      bordered={false}
    >
      <div className="flex items-center justify-between">
        <div>
          <Title level={2} className="text-white m-0">
            Détails du Véhicule
          </Title>
          <Text className="text-white opacity-80">
            Information complète du véhicule matricule{" "}
            <span className="font-bold">{matricule.toUpperCase()}</span>
            {brand && ` - ${brand}`}
            {model && ` ${model}`}
          </Text>
        </div>
        <div>
          <CarOutlined className="text-5xl text-white opacity-70" />
        </div>
      </div>
    </Card>
  );
};

export default VehicleHeader;